import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Base64Service {

  constructor() { }

  private __KEY_STR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  private _utf8_encode(string: string) {
      string = string.replace(/\r\n/g, '\n');
      let utfText = '';

      for (let n = 0; n < string.length; n++) {
          const c: number = string.charCodeAt(n);
          if (c < 128) {
              utfText += String.fromCharCode(c);
          } else if ((c > 127) && (c < 2048)) {
              utfText += String.fromCharCode((c >> 6) | 192);
              utfText += String.fromCharCode((c & 63) | 128);
          } else {
              utfText += String.fromCharCode((c >> 12) | 224);
              utfText += String.fromCharCode(((c >> 6) & 63) | 128);
              utfText += String.fromCharCode((c & 63) | 128);
          }
      }

      return utfText;
  }

  private _utf8_decode(utfText:any) {
      let str = '';
      let i = 0;
      let [c, c2, c3] = [0, 0, 0];

      while (i < utfText.length) {
          c = utfText.charCodeAt(i);
          if (c < 128) {
              str += String.fromCharCode(c);
              i++;
          } else if ((c > 191) && (c < 224)) {
              c2 = utfText.charCodeAt(i + 1);
              str += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
              i += 2;
          } else {
              c2 = utfText.charCodeAt(i + 1);
              c3 = utfText.charCodeAt(i + 2);
              str += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
              i += 3;
          }
      }

      return str;
  }

  encode(input:any) {
      let output = '';
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;

      input = this._utf8_encode(input);

      while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
              enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
              enc4 = 64;
          }

          output = output + this.__KEY_STR.charAt(enc1) + this.__KEY_STR.charAt(enc2) + this.__KEY_STR.charAt(enc3) + this.__KEY_STR.charAt(enc4);
      }

      return output;
  }

  decode(input:any) {
      let output = '';
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;

      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      while (i < input.length) {
          enc1 = this.__KEY_STR.indexOf(input.charAt(i++));
          enc2 = this.__KEY_STR.indexOf(input.charAt(i++));
          enc3 = this.__KEY_STR.indexOf(input.charAt(i++));
          enc4 = this.__KEY_STR.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
              output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
              output = output + String.fromCharCode(chr3);
          }
      }

      output = this._utf8_decode(output);
      return output;
  }
}
